export const en = {
  messages: {
    notFound: 'Information not found',
    select: 'Select a value',
    loading: 'Loading',
    deleteError: 'Could not delete the record',
    yes: 'Yes',
    no: 'No',
  },
  pagination: {
    of: 'of',
    issues: {
      singular: 'issue',
      plural: 'issues'
    }
  },
  attachment: {
    delete: {
      title: 'Delete Attachment',
      content: 'Are you sure you want to delete this attachment?',
      confirm: 'Delete',
      cancel: 'Cancel'
    }
  },
  tableToolbar: {
    reload: 'Reload',
    density: 'Density',
    densityDefault: 'Default',
    densityMiddle: 'Middle',
    densityCompact: 'Compact',
    columns: 'Columns',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit fullscreen'
  },
  buttons: {
    create: 'Create',
    export: 'Export',
    import: 'Import',
    more: 'More',
    bulkUpdate: 'Bulk Update',
    archiveSelected: 'Archive Selected',
    refreshData: 'Refresh Data',
    clear: 'Clear',
    clearAll: 'Clear All'
  },
  tags:{
    completed: 'Completed',
    pending: 'Pending',
    inProgress: 'In Progress'
  },
  navigation: {
    workspace: 'Workspace',
    appName: 'Giro Web',
    appSwitcher: 'Giro Apps',
    selectModule: 'Select a module',
    dashboard: 'Dashboard',
    documents: 'Documents',
    reports: 'Reports',
    settings: 'Settings',
    modules: {
      incidents: {
        title: 'My Incidents',
        subtitle: 'Manage your incidents'
      },
      events: {
        title: 'My Events',
        subtitle: 'Manage the losses'
      },
      risks: {
        title: 'My LinkedRisks',
        subtitle: 'Manage your risks'
      },
      plans: {
        title: 'My Plans',
        subtitle: 'Manage your plans'
      },
      indicators: {
        title: 'My Indicators',
        subtitle: 'Manage your indicators'
      }
    },
    appSwitcherModules: {
      incidents: 'Incidents',
      assets: 'Assets',
      actionPlans: 'Action Plans',
      risks: 'Risks',
      indicators: 'Indicators',
      suppliers: 'Suppliers',
      lossEvents: 'Loss Events',
      bia: 'BIA',
      audit: 'Audit'
    },
    subtitles: {
      dashboard: 'Summary and history',
      documents: 'Manage your documents',
      reports: 'Create your reports',
      settings: 'Adapt GIRO to your needs'
    },
    userMenu: {
      profile: 'My Profile',
      settings: 'Settings',
      password: 'Change Password',
      notifications: 'Notifications',
      activityLog: 'Activity Log',
      help: 'Help & Support',
      logout: 'Log Out',
      language: 'Language'
    }
  },
  issues: {
    title: 'Issues',
    createIssue: 'Create Issue',
    saveIssue: 'Save Issue',
    saveApproval: 'Save Approval',
    exportData: 'Export',
    importData: 'Import',
    filters: 'Filters',
    status: 'Status',
    impact: 'Impact',
    origin: 'Origin',
    dateRange: 'Date Range',
    searchPlaceholder: 'Search issues...',
    subtitle: 'Track, triage and resolve incidents across your organization',
    date: {
      anytime: 'Anytime',
      olderThanWeek: 'Older than a week',
      olderThanMonth: 'Older than a month',
      olderThan6Months: 'Older than 6 months',
      olderThanYear: 'Older than a year',
      customRange: 'Custom range'
    },
    tabs: {
      all: 'All',
      open: 'Open',
      assignedToMe: 'Assigned to me',
      closed: 'Closed',
      archived: 'Archived'
    },
    stats: {
      openIssues: 'Open issues',
      blocking: 'Blocking',
      avgTimeToResolve: 'Avg. time to resolve',
      resolvedThisWeek: 'Resolved this week'
    },
    columns: {
      code: 'Code',
      description: 'Description',
      impact: 'Impact',
      origin: 'Origin',
      effect: 'Effect',
      dateReport: 'Date Report',
      id: 'ID',
      title: 'Title',
      status: 'Status',
      priority: 'Priority',
      assignee: 'Assignee',
      updated: 'Updated'
    },
    messages: {
      createSuccess: 'Issue created successfully',
      createError: 'Failed to create issue',
      updateSuccess: 'Issue updated successfully',
      approvalSuccess: 'Issue was approved successfully',
      loadError: 'Failed to load issues',
      searchError: 'Failed to search issues',
      exportInfo: 'Export functionality to be implemented',
      importInfo: 'Import functionality to be implemented'
    },
    options: {
      noOptionsAvailable: 'No options available',
      status: {
        name: 'Status',
        filterKey: 'status',
      },
      impact: {
        name: 'Impact',
        filterKey: 'impact',
      },
      origin: {
        name: 'Origin',
        filterKey: 'origin',
      },
      channelAffected: {
        name: 'Channel Affected',
        filterKey: 'channelAffected',
      },
      effect: {
        name: 'Effect',
        filterKey: 'effect',
      },
      issueActionPlan: {
        name: 'Action Plan',
        filterKey: 'issueActionPlan',
      },
      channelReport: {
        name: 'Channel Report',
        filterKey: 'channelReport',
      },
      resourceAffected: {
        name: 'Resource Affected',
        filterKey: 'resourceAffected',
      }
    },
    detail: {
      breadcrumb: {
        issues: 'Issues',
        detail: 'Issue Detail',
        copyLink: 'Copy link',
        linkCopied: 'Link copied'
      },
      title: 'Register issue',
      header: {
        titlePrefix: 'Issue:',
        newTitle: 'New incident',
        subtitle: 'Detail information about the issue: form, impact assessment, approval and monitoring',
        cancel: 'Cancel'
      },
      navigation: {
        issueDetails: {
          title: 'Incident',
          panelTitle: 'Register Issue',
          subtitle: 'Form for edit issue'
        },
        approval: {
          title: 'Approval',
          panelTitle: 'Approve issue',
          subtitle: 'Approve issue'
        },
        impactAssessment: {
          title: 'Impact',
          panelTitle: 'Impact Assessment Issue',
          subtitle: 'Evaluate issue impact'
        },
        monitoring: {
          title: 'Activity & Monitoring',
          panelTitle: 'Issue Monitoring',
          subtitle: 'Track issue progress'
        },
        actionPlans: {
          title: 'Action Plans',
          panelTitle: 'Action Plans linked to Issue',
          subtitle: 'Define corrective actions'
        },
        risks: {
          title: 'LinkedRisks',
          panelTitle: 'Risks associated to Issue',
          subtitle: 'Assess associated risks'
        }
      },
      form: {
        tabs: {
          register: {
            title: 'Incident information',
          },
          report: {
            title: 'Report by',
          }
        },
        sections: {
          basic: 'Basic Information',
          classification: 'Classification',
          additional: 'Additional Information'
        },
        summary: {
          code: 'Code',
          status: 'Status',
          reportedBy: 'Reported by',
          reportedOn: 'Reported on',
          attachments: 'Attachments',
          fileCountSuffix: 'file(s)',
          maxFiles: 'Maximum 50 files, 10MB each'
        },
        code: {
          name: 'Code',
          placeHolder: 'Enter an issue code',
          validation: {
            required: 'Code is required'
          }
        },
        title: {
          name: 'Title',
          placeHolder: 'Enter an issue title',
          validation: {
            required: 'Title is required'
          }
        },
        origin: {
          name: 'Origin',
          placeHolder: 'Enter an origin',
          validation: {
            required: 'Origin is required'
          }
        },
        effect: {
          name: 'Effect',
          placeHolder: 'Enter an effect',
          validation: {
            required: 'Effect is required'
          }
        },
        status: {
          name: 'Status',
          placeHolder: 'Enter a status',
          validation: {
            required: 'Status is required'
          }
        },
        description: {
          name: 'Description',
          placeHolder: 'Enter a description',
          validation: {
            required: 'Description is required',
            min: 'Description must be at least 10 characters',
            max: 'Description must be at most 3000 characters'
          }
        },
        comments: {
          name: 'Comments',
          placeHolder: 'Enter a comment',
          validation: {
            required: 'Comment is required',
            min: 'Comment must be at least 10 characters',
            max: 'Comment must be at most 1000 characters'
          }
        },
        supplier: 'Supplier',
        dateReport: {
          name: 'Date Report',
          placeHolder: 'Select a report date',
          validation: {
            required: 'Date Report is required'
          }
        },
        dateInit: {
          name: 'Date Init',
          placeHolder: 'Select a date'
        },
        dateEnd: {
          name: 'Date End',
          placeHolder: 'Select a date'
        },
        dateDiscovery: {
          name: 'Date Discover',
          placeHolder: 'Select a date'
        },
        dateMitigation: {
          name: 'Date Mitigation',
          placeHolder: 'Select a date'
        },
        issueActionPlan: {
          name: 'Action Plan',
          placeHolder: 'Select an action plan',
          validation: {
            required: 'Action Plan is required'
          }
        },
        channelAffected: {
          name: 'Channel Affected',
          placeHolder: 'Select a channel',
          validation: {
            required: 'Channel Affected is required'
          }
        },
        resourceAffected: {
          name: 'Resource Affected',
          placeHolder: 'Select an action plan',
          validation: {
            required: 'Action Plan is required'
          }
        },
        process: {
          name: 'Process',
          placeHolder: 'Select an process',
          validation: {
            required: 'Process is required'
          }
        },
        area: {
          name: 'Area',
          placeHolder: 'Select an area',
          validation: {
            required: 'Area is required'
          }
        },
        channelReport: {
          name: 'Channel Report',
          placeHolder: 'Select a channel report',
          validation: {
            required: 'Channel Report is required'
          }
        },
        reportingUser: {
          name: 'Reporting User',
          placeHolder: 'Select an user',
          validation: {
            required: 'User is required'
          }
        },
        rootCause: {
          name: 'Root Cause',
          placeHolder: 'Enter a root cause',
          validation: {
            required: 'Root Cause is required',
            max: 'Root Cause must be at most 600 characters'
          }
        },
        resolvingArea: {
          name: 'Resolving Area',
          placeHolder: 'Select an area',
          validation: {
            required: 'Resolving Area is required'
          }
        },
        hasTicket: {
          name: 'Inform to supervisor',
          validation: {
            required: 'Is required'
          }
        },
        typeThreat: {
          name: 'Type Threat',
          placeHolder: 'Select an option',
          validation: {
            required: 'Type Threat is required'
          }
        },
        typeAssetAffected: {
          name: 'Type asset Affected',
          placeHolder: 'Select an option',
          validation: {
            required: 'Type asset affected is required'
          }
        },
        numberCustomerAffected: {
          name: 'Number Customer Affected',
          placeHolder: 'Enter a number',
          validation: {
            required: 'Number is required'
          }
        },
        lossCustomer: {
          name: 'Loss Customer',
          placeHolder: 'Enter a cost',
          validation: {
            required: 'Loss is required'
          }
        },
        costMitigation: {
          name: 'Cost Mitigation',
          placeHolder: 'Enter a cost',
          validation: {
            required: 'Cost mitigation is required'
          }
        },
        file: {
          name: 'Attachment',
          placeHolder: 'Select a file',
          validation: {
            required: 'Attachment is required'
          }
        }
      }
    },
    approval: {
      by: 'By',
      assignedTo: 'Assigned to',
      workflow: {
        title: 'Approval workflow'
      },
      steps: {
        submitted: 'Submitted',
        teamLead: 'Team Lead Approval',
        manager: 'Pending Manager Approval',
        final: 'Final Review'
      },
      actions: {
        approve: 'Approve',
        reject: 'Reject',
        addComment: 'Add comment'
      },
      comments: {
        title: 'Add comment'
      },
      summary: {
        title: 'Issue Summary',
        code: 'Code',
        status: 'Status',
        reportedBy: 'Reported By',
        reportedOn: 'Reported On'
      },
      messages: {
        approveError: 'Failed to approve issue',
        rejectSuccess: 'Issue was rejected',
        rejectError: 'Failed to reject issue',
        commentSuccess: 'Comment added'
      },
      form: {
        date: {
          name: 'Approval date',
          placeHolder: 'Select a date',
          validation: {
            required: 'Approval date is required'
          }
        },
        user: {
          name: 'Approval user',
          placeHolder: 'Select an user',
          validation: {
            required: 'Approval user is required'
          }
        },
        comments: {
          name: 'Comments',
          placeHolder: 'Add approval comments or notes...',
          validation: {
            required: 'Comment is required',
            requiredForReject: 'A comment is required to reject'
          }
        }
      }
    },
    impactAssessment: {
      saveAssessment: 'Save assessment',
      card: {
        title: 'Impact variables assessment',
        generalAssessment: 'General impact assessment'
      },
      columns: {
        variable: 'Variable / Group',
        assessment: 'Impact Assessment',
        level: 'Impact Level'
      },
      fields: {
        assessment: {
          placeholder: 'Select impact level'
        }
      },
      severity: {
        high: 'High',
        mediumHigh: 'Medium-High',
        medium: 'Medium',
        lowInfo: 'Low / Information',
        none: 'None'
      },
      score: {
        low: 'Low',
        information: 'Information',
        medium: 'Medium',
        high: 'High',
        critical: 'Critical'
      },
      groups: {
        operationalRisk: 'Operational Risk',
        securityInformation: 'Security & Information',
        businessContinuity: 'Business Continuity'
      },
      variables: {
        financialImpact: 'Financial Impact',
        imageReputation: 'Image & Reputation',
        dataConfidentiality: 'Data Confidentiality',
        dataIntegrity: 'Data Integrity',
        systemAvailability: 'System Availability',
        regulatoryCompliance: 'Regulatory Compliance',
        accessControl: 'Access Control',
        operationalImpact: 'Operational Impact',
        customerImpact: 'Customer Impact',
        recoveryTimeObjective: 'Recovery Time Objective (RTO)',
        serviceLevelImpact: 'Service Level Impact'
      },
      messages: {
        saveSuccess: 'Impact assessment saved',
        saveError: 'Failed to save impact assessment'
      }
    },
    activity: {
      compose: {
        title: 'Add activity',
        placeholder: 'Add a comment, update, or note about this issue...',
        attach: 'Attach files',
        post: 'Post activity'
      },
      timeline: {
        title: 'Activity timeline',
        empty: 'No activity yet'
      },
      verbs: {
        commented: 'commented',
        updated: 'updated',
        attached: 'attached file'
      },
      summary: {
        title: 'Issue Summary',
        code: 'Code',
        status: 'Status',
        reportedBy: 'Reported By',
        reportedOn: 'Reported On'
      },
      stats: {
        title: 'ACTIVITY STATS',
        comments: 'Comments',
        attachments: 'Attachments',
        lastActivity: 'Last Activity'
      },
      attachment: {
        view: 'View',
        download: 'Download'
      },
      messages: {
        postSuccess: 'Activity posted',
        postError: 'Failed to post activity',
        attachmentError: 'Could not open attachment'
      }
    }
  },
  filters: {
    options: {
      noOptionsAvailable: 'No options available',
    },
    result: 'result',
    results: 'results',
    found: 'found',
    founds: 'found',
  },
  settings: {
    title: 'Settings',
    menu: {
      overview: 'Overview',
      statusIssues: 'Status Issues',
      groupParameters: 'Group of Parameters',
      impactAssessment: 'Impact Assessment',
      notifications: 'Notifications',
      emailServer: 'Email Server',
      transactionRules: 'Transaction Rules'
    },
    content: {
      overview: {
        title: 'Settings overview',
        subtitle: 'Manage and configure GIRO to fit your needs',
        description: 'Browse and configure all settings',
        cardCta: 'Configure',
        snippets: {
          loading: 'Loading…',
          statusIssues: '{count} statuses',
          groupParameters: 'Coming soon',
          impactAssessment: '{count} variable groups',
          notifications: 'Email and alerts',
          emailServer: 'SMTP & delivery',
          transactionRules: 'Coming soon'
        }
      },
      statusIssues: {
        title: 'Status Issues Configuration',
        description: 'Manage and configure issue statuses',
        filter: {
          entity: 'Entity',
          all: 'All entities',
          placeholder: 'Filter by entity'
        },
        buttons: {
          add: 'Add status',
          save: 'Save',
          cancel: 'Cancel',
          edit: 'Edit',
          delete: 'Delete'
        },
        columns: {
          code: 'Code',
          name: 'Name',
          description: 'Description',
          entity: 'Entity',
          sequence: 'Order',
          active: 'Active',
          actions: 'Actions'
        },
        confirm: {
          deleteTitle: 'Delete status?',
          deleteDescription: 'This action cannot be undone.',
          ok: 'Delete',
          cancel: 'Cancel'
        },
        messages: {
          created: 'Status created',
          updated: 'Status updated',
          deleted: 'Status deleted',
          saveError: 'Could not save status',
          deleteError: 'Could not delete status',
          empty: 'No statuses found',
          required: 'Required'
        }
      },
      groupParameters: {
        title: 'Group of Parameters',
        description: 'Configure parameter groups and values'
      },
      impactAssessment: {
        title: 'Impact Assessment Configuration',
        description: 'Define impact assessment criteria',
        header: {
          actions: {
            history: 'Version history'
          }
        },
        steps: {
          pillFormat: 'Step {current} of {total}',
          scale: {
            title: 'Scale bands',
            subtitle: 'Qualitative grades & numeric ranges'
          },
          variables: {
            title: 'Variables & options',
            subtitle: 'Catalog scored against the scale'
          }
        },
        optionPanel: {
          meta: {
            kindGroup: 'group',
            kindVariable: 'variable'
          }
        },
        scaleDrawer: {
          previewLabel: 'Preview',
          formulaPlaceholder: 'score BETWEEN 0 AND 2',
          formulaHint: 'Used by the assessment engine to classify a numeric score into this band. Reference the score as `score`.',
          formulaSuggestions: 'Suggestions',
          formulaInvalid: 'Invalid formula. Allowed: MAX, MIN, SUM, AVERAGE, COUNTIF, AND, OR, the variable `values`, numbers, and comparison operators.'
        },
        optionDrawer: {
          bandPickerLabel: 'Scale band'
        },
        variableDrawer: {
          typeLabel: 'Node type',
          typeGroup: 'Group',
          typeVariable: 'Variable'
        },
        sections: {
          scaleBands: {
            title: 'Scale bands',
            description: 'Define the impact levels (e.g. Low, Medium, High) used across the assessment, with their colors, ordering and formulas.'
          }
        },
        buttons: {
          previous: 'Previous',
          next: 'Next',
          finish: 'Finish'
        },
        tree: {
          title: 'Groups & variables',
          noVariablesFound: 'No variables found',
          tags: {
            completed: 'Completed'
          },
          actions: {
            addGroup: 'Add group',
            editGroup: 'Edit group',
            deleteGroupConfirm: 'Delete this group? Its variables and values will also be removed.',
            addVariable: 'Add variable',
            editVariable: 'Edit variable',
            deleteVariableConfirm: 'Delete this variable? Its values will also be removed.'
          },
          form: {
            groupName: 'Group name',
            variableName: 'Variable name'
          }
        },
        table: {
          columns: {
            name: 'Name',
            impact: 'Impact',
            actions: 'Actions'
          },
          actions: {
            save: 'Save',
            cancel: 'Cancel',
            edit: 'Edit',
            deleteConfirm: 'Delete this value?',
            addValue: 'Add value'
          },
          messages: {
            noValuesFound: 'No values found for selected node',
            selectNode: 'Please select a node from the tree'
          }
        },
        formulaTable: {
          columns: {
            description: 'Impact',
            color: 'Color',
            displayOrder: 'Order',
            formula: 'Formula',
            actions: 'Actions'
          },
          actions: {
            save: 'Save',
            cancel: 'Cancel',
            edit: 'Edit',
            add: 'Add scale band',
            delete: 'Delete',
            deleteConfirm: 'Delete this scale band?'
          },
          messages: {
            noDataFound: 'No impact options found'
          }
        }
      },
      notifications: {
        title: 'Notifications',
        description: 'Configure notification settings and preferences',
        parameterCode: 'Parameter code',
        searchPlaceholder: 'Search notification',
        countActive: '{active} of {total} notifications active',
        empty: 'No notification matches the search.',
        filters: {
          all: 'All',
          active: 'Active',
          inactive: 'Inactive',
          custom: 'With custom template'
        },
        dirty: {
          unsaved: 'Unsaved changes',
          saved: 'All changes saved',
          invalidRecipient: 'A valid master recipient is missing in “{field}”',
          saveBlocked: 'Enter a valid master recipient'
        },
        switch: {
          on: 'Yes',
          off: 'No'
        },
        buttons: {
          save: 'Save changes',
          cancel: 'Cancel'
        },
        messages: {
          saved: 'Notification settings saved',
          saveError: 'Could not save notification settings',
          loadError: 'Could not load the notification settings',
          reset: 'Changes discarded'
        },
        banner: {
          emailNotConfigured: 'Configure the email server so these notifications can be sent.',
          configureAction: 'Configure email server'
        },
        sections: {
          count: '{active} of {total} active',
          incidents: {
            abbr: 'IN',
            title: 'Incidents',
            description: 'Notifications related to the incident lifecycle'
          }
        },
        options: {
          origin_effect: 'Origin or effect',
          all: 'All fields',
          band_changed: 'Only when the level changes',
          any: 'Any reassessment'
        },
        fields: {
          SEND_EMAIL_INCIDENT_CREATED: {
            label: 'Notify when an incident is created',
            description: 'Sends a notification when a new incident is registered.'
          },
          SEND_EMAIL_INCIDENT_MODIFIED: {
            label: 'Notify when an incident is modified',
            description: 'Sends a notification when changes are made to an incident.'
          },
          INCIDENT_MODIFIED_FIELDS: {
            label: 'Fields that trigger the notification',
            description: 'Send the modification notification only when the origin or effect fields change, or on any change.'
          },
          SEND_EMAIL_INCIDENT_STATUS_CHANGED: {
            label: 'Notify when an incident changes status',
            description: 'Sends a notification when an incident moves to a different status.'
          },
          SEND_EMAIL_INCIDENT_MONITORING: {
            label: 'Notify when a monitoring entry is registered',
            description: 'Sends a notification when a monitoring / follow-up record is added to the incident.'
          },
          SEND_EMAIL_INCIDENT_ASSESSMENT: {
            label: 'Notify when the incident impact is assessed',
            description: 'Sends a notification when the impact assessment of the incident is completed.'
          },
          SEND_EMAIL_INCIDENT_ANNULLED: {
            label: 'Notify when an incident is annulled',
            description: 'Sends a notification when an incident is annulled.'
          },
          SEND_EMAIL_INCIDENT_MONITORING_EDITED: {
            label: 'Notify when a monitoring entry is edited',
            description: 'Sends a notification when an existing monitoring entry of the incident is modified.'
          },
          SEND_EMAIL_INCIDENT_MONITORING_DELETED: {
            label: 'Notify when a monitoring entry is deleted',
            description: 'Sends a notification when a monitoring entry of the incident is deleted.'
          },
          SEND_EMAIL_INCIDENT_REASSESSED: {
            label: 'Notify when the impact is reassessed',
            description: 'Sends a notification when a new version of the impact assessment is registered.'
          },
          ASSESSMENT_CHANGE_SCOPE: {
            label: 'Scope that triggers the notification',
            description: 'Send the reassessment notification only when the impact level changes, or on any reassessment.'
          }
        },
        recipients: {
          note: '“To” receives this notice when no assignee is set. Cc addresses are always copied. Press Enter or comma to separate several addresses.',
          master: 'To',
          cc: 'Cc',
          edit: 'Edit recipients',
          done: 'Done',
          emptyMaster: 'No recipient',
          emptyCc: 'No copies',
          optional: 'Optional'
        },
        masterRecipient: {
          label: 'Master recipient',
          placeholder: 'operations@teslatec.pe',
          validation: {
            required: 'Enter at least one address. This field is required.',
            invalid: 'Fix the format of: {emails}',
            tooMany: 'Maximum {max} master recipients.'
          }
        },
        extraRecipients: {
          placeholder: 'supervisor@teslatec.pe',
          invalid: 'Fix the format of: {emails}',
          tooMany: 'Maximum {max} Cc addresses.'
        },
        template: {
          eyebrow: 'Email template',
          configure: 'Configure template',
          none: 'No template',
          custom: 'Customized',
          subject: 'Subject',
          subjectPlaceholder: 'Email subject',
          body: 'Message body',
          tabs: {
            edit: 'Edit',
            preview: 'Preview'
          },
          variables: {
            title: 'Available variables',
            hint: 'Click to insert into {target}',
            subject: 'the subject',
            body: 'the body'
          },
          vars: {
            incidente: {
              codigo: {
                hint: 'Sequential incident code',
                sample: 'INC-2481'
              },
              titulo: {
                hint: 'Incident title',
                sample: 'Main link outage at the Lima office'
              },
              estado: {
                hint: 'Current incident status',
                sample: 'In progress'
              },
              prioridad: {
                hint: 'Assigned priority',
                sample: 'High'
              }
            },
            usuario: {
              nombre: {
                hint: 'Email recipient',
                sample: 'Yomar Huamani'
              }
            },
            fecha: {
              hint: 'Date and time of the event',
              sample: '08/04/2026 09:14'
            },
            enlace: {
              hint: 'Direct link to the record',
              sample: 'https://giro.teslatec.pe/incidentes/INC-2481'
            },
            actor: {
              nombre: {
                hint: 'Name of the person who performed the action',
                sample: 'Diana Torres'
              }
            },
            seguimiento: {
              descripcion: {
                hint: 'Monitoring entry description',
                sample: 'Contacted the provider to coordinate restoring the link.'
              },
              fecha: {
                hint: 'Monitoring entry date',
                sample: '08/04/2026 08:30'
              }
            },
            evaluacion: {
              nivelAnterior: {
                hint: 'Impact level before the reassessment',
                sample: 'Medium'
              },
              nivelNuevo: {
                hint: 'Impact level after the reassessment',
                sample: 'High'
              },
              version: {
                hint: 'Assessment version number',
                sample: '2'
              }
            }
          },
          preview: {
            note: 'Preview using sample data from incident {code}.',
            from: 'From',
            to: 'To',
            subject: 'Subject',
            sender: 'Giro Incidents <no-reply@giro.teslatec.pe>',
            recipient: 'user@company.com'
          },
          buttons: {
            reset: 'Restore default',
            cancel: 'Cancel',
            save: 'Save template'
          },
          messages: {
            saved: 'Template saved',
            reset: 'Default template restored',
            conflict: 'This template was changed by someone else. It was refreshed with the latest version — review the content and save again.',
            saveError: 'Could not save the template'
          }
        }
      },
      emailServer: {
        title: 'Email server',
        description: 'Configure the SMTP server used to send notifications, invitations, and issue digests. Changes apply to every sub-app in this workspace.',
        cardDescription: 'Configure the SMTP server and email delivery options',
        parameterCode: 'Parameter code',
        defaultHostLabel: 'the SMTP server',
        status: {
          verified: 'Verified',
          notVerified: 'Not verified'
        },
        sections: {
          template: {
            title: 'Template',
            description: 'How outgoing messages identify themselves.'
          },
          connection: {
            title: 'Connection & Authentication',
            description: 'Where and how messages are relayed.'
          },
          delivery: {
            title: 'Delivery options',
            description: 'Transport and routing configuration'
          }
        },
        fields: {
          from: {
            label: 'From',
            placeholder: 'Sender email address'
          },
          fromName: {
            label: 'From display name',
            placeholder: 'Display name for Sender email address',
            tooltip: 'A user-friendly name displayed as the sender of outgoing emails.'
          },
          replyTo: {
            label: 'Reply to',
            placeholder: 'Reply to email address'
          },
          replyToName: {
            label: 'Reply to display name',
            placeholder: 'Display name for "reply to" email address',
            tooltip: 'A user-friendly name displayed for the "reply to" address.'
          },
          envelopeFrom: {
            label: 'Envelope from',
            placeholder: 'Sender envelope email address',
            tooltip: 'Return address used for bounces (SMTP envelope).'
          },
          host: {
            label: 'Host',
            placeholder: 'smtp.example.com'
          },
          port: {
            label: 'Port',
            placeholder: 'SMTP port (defaults to 25)',
            suggested: 'Suggested: {port}'
          },
          encryption: {
            label: 'Encryption',
            ssl: 'Enable SSL',
            starttls: 'Enable StartTLS'
          },
          auth: {
            label: 'Authentication',
            enabled: 'Enabled',
            disabled: 'Disabled'
          },
          username: {
            label: 'Username',
            placeholder: 'SMTP username'
          },
          password: {
            label: 'Password',
            placeholder: 'SMTP password',
            storedPlaceholder: 'Password stored — type a new one to replace it'
          },
          debug: {
            label: 'Enable Debug SMTP',
            tooltip: 'Writes the full SMTP transcript to the application log.'
          }
        },
        testInfo: 'When testing the connection an e-mail will be sent to the current user ({email}).',
        testing: 'Contacting {host}…',
        buttons: {
          save: 'Save',
          test: 'Test connection',
          revert: 'Revert'
        },
        dirty: {
          unsaved: 'Unsaved changes',
          saved: 'All changes saved'
        },
        messages: {
          saved: 'Email server configuration saved.',
          saveError: 'Could not save the email server configuration',
          loadError: 'Could not load the email server configuration',
          testSuccess: 'Connection successful. A test e-mail was sent to {email}.',
          testError: 'Could not reach the SMTP server',
          required: 'Required',
          invalidEmail: 'Enter a valid email address'
        }
      },
      transactionRules: {
        title: 'Transaction Rules',
        description: 'Define business rules for transactions'
      }
    }
  },
  events: {
    title: 'Loss events',
    subtitle: 'Capture, categorise and close operational losses across the firm.',
    createEvent: 'Log event',
    export: 'Export',
    customise: 'Customise',
    saveEvent: 'Save Event',
    stats: {
      openEvents: 'Open events',
      grossLossYtd: 'Gross loss YTD',
      netLossYtd: 'Net loss YTD',
      avgTimeToClose: 'Avg. time to close',
      trendVsLastWeek: 'vs last week',
      trendThisMonth: 'this month',
      trendRecovered: 'recovered',
      trendVsLastQuarter: 'vs last quarter',
    },
    severity: {
      critical: 'Critical',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    tabs: {
      all: 'All',
      open: 'Open',
      investigating: 'Investigating',
      recovered: 'Recovered',
      closed: 'Closed',
    },
    columns: {
      id: 'Event ID',
      date: 'Date',
      description: 'Description',
      type: 'Category',
      businessLine: 'Business unit',
      severity: 'Severity',
      grossLoss: 'Gross loss',
      netLoss: 'Net loss',
      status: 'Status',
      owner: 'Owner',
    },
    filters: {
      label: 'Filters',
      status: 'Status',
      severityTier: 'Severity',
      lossEventType: 'Event Type',
      businessLine: 'Business Line',
      addYtd: '+ YTD',
    },
    groupBy: {
      label: 'Group',
      none: 'None',
      lossEventType: 'Category',
      businessLine: 'Business unit',
      status: 'Status',
      severityTier: 'Severity',
    },
    sortBy: {
      label: 'Sort',
      occurrenceDate: 'Date',
      externalCode: 'Event ID',
      grossLoss: 'Gross loss',
      netLoss: 'Net loss',
    },
    date: {
      anytime: 'Anytime',
      olderThanWeek: 'Older than a week',
      olderThanMonth: 'Older than a month',
      olderThan6Months: 'Older than 6 months',
      olderThanYear: 'Older than a year',
      customRange: 'Custom range',
    },
    messages: {
      loadError: 'Error loading events',
    },
    detail: {
      header: {
        titlePrefix: 'Event',
        subtitle: 'Loss event detail',
        cancel: 'Cancel',
      },
      navigation: {
        eventDetails: {title: 'Event', subtitle: 'Event information'},
        financial: {title: 'Financial', subtitle: 'Recoveries and losses'},
        approval: {title: 'Approval', subtitle: 'Approval workflow'},
        activity: {title: 'Activity', subtitle: 'Notes and tracking'},
      },
    },
    form: {
      shortDescription: 'Short Description',
      shortDescriptionRequired: 'Short description is required',
      shortDescriptionPlaceholder: 'Enter a brief description of the event',
      detailedDescription: 'Detailed Description',
      detailedDescriptionPlaceholder: 'Describe the loss event in detail',
      occurrenceDate: 'Occurrence Date',
      discoveryDate: 'Discovery Date',
      accountingDate: 'Accounting Date',
      severityTier: 'Severity Tier',
      severityTierPlaceholder: 'Select tier',
      lossEventType: 'Event Type',
      lossEventTypePlaceholder: 'Select type',
      businessLine: 'Business Line',
      businessLinePlaceholder: 'Select business line',
      grossLoss: 'Gross Loss',
      netLoss: 'Net Loss',
      status: 'Status',
      statusPlaceholder: 'Select status',
      saveSuccess: 'Event saved successfully',
      createSuccess: 'Event created successfully',
      saveError: 'Error saving event',
    },
    financial: {
      addRecovery: 'Add Recovery',
      empty: 'No recoveries recorded',
      columns: {
        date: 'Date',
        type: 'Type',
        amount: 'Amount',
        description: 'Description',
      },
    },
    activity: {
      addNote: 'Add Note',
      notePlaceholder: 'Enter a tracking note...',
      saveNote: 'Save Note',
      empty: 'No notes recorded',
    },
    approval: {
      engineTitle: 'Approval Engine',
      engineDescription: 'The approval workflow is managed through the shared approval engine.',
    },
  }
};
